/**
 * The W1 push payload — one match's TO, SJ and TJ — and the one sentence that describes it.
 *
 * Authority: `09-tms-write-paths.md` §1 (W1), §2 (the read-modify-write requirement and
 * day-and-competition batching), §5 gate 6 (non-destructive payloads) and §5.1 (the
 * confirmation and the receipt); `03-appointments.md` §A9 and §A11; the Technical Delegate's
 * ruling of 16 September 2026 (RUN 82): push a matchday's appointments, and the completed
 * games, and lock what TMS holds.
 *
 * **Why it lives in `packages/shared`**, for `tms-push.ts`'s reason: the confirmation dialogue,
 * the receipt and the gateway must describe the same thing in the same words, and one builder
 * used by the API and the browser is the only way they cannot drift.
 *
 * **Only the three technical slots, and nothing else.** There is no field for an umpire slot, a
 * kit colour or the day's Publishing control, so no payload can ask for one to be written. The
 * TMS form a W1 push saves also carries the four umpire selects and the eight kit colours, and a
 * transport keeps every one of those exactly as it read them (§2) — the payload names what may
 * change, and that is the whole of it.
 *
 * Nothing here talks to TMS, opens a socket or knows a URL. It is data.
 */
/** The slots a W1 push writes, in the order the dialogue, the receipt and the form list them. */
export const TMS_APPOINTMENT_PUSH_SLOTS = ["TO", "SJ", "TJ"];
/** `Men's` / `Women's` — the word §A9's dialogue uses for a batch. */
export function appointmentCompetitionWord(gender) {
    return gender === "m" ? "Men's" : "Women's";
}
/**
 * `Men's M01 · IND v JPN — TO KANG Min · SJ OKAFOR Ada · TJ SATO Rei`
 *
 * The one sentence the dialogue lists, the receipt stores and the outcome panel repeats, so a
 * receipt cannot describe a crew other than the one that was confirmed.
 */
export function summariseAppointmentPayload(payload) {
    const teams = `${payload.homeTeamCode ?? "TBC"} v ${payload.awayTeamCode ?? "TBC"}`;
    const crew = TMS_APPOINTMENT_PUSH_SLOTS.map((slot) => `${slot} ${payload.slots[slot].mediaName}`).join(" · ");
    return (`${appointmentCompetitionWord(payload.competitionGender)} ${payload.displayMatchNo} · ` +
        `${teams} — ${crew}`);
}
//# sourceMappingURL=tms-appointment-push.js.map